(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks/assets/javascripts/use-is-tipsinfo-enabled.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks/assets/javascripts/use-is-tipsinfo-enabled.js');
"use strict";


const {
  useMemo
} = React;
const {
  useSelector
} = ReactRedux;
const {
  selectTipsinfo
} = svs.components.tipsen.selectors;
const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);

const useIsTipsinfoEnabled = () => {
  const tipsinfoState = useSelector(selectTipsinfo);
  const standardContext = useMemo(() => {
    const obj = {};
    for (const key in tipsinfoState) {
      if (tipsinfoState[key] && 'state' in tipsinfoState[key]) {
        obj["is".concat(capitalizeFirstLetter(key), "Enabled")] = tipsinfoState[key].state;
      }
    }
    obj.isAnyTipsinfoEnabled = Object.values(obj).some(value => Boolean(value));
    return obj;
  }, [tipsinfoState]);
  const resultContext = useMemo(() => {
    const obj = {};
    for (const key in tipsinfoState) {
      if (tipsinfoState[key] && 'stateResult' in tipsinfoState[key]) {
        obj["is".concat(capitalizeFirstLetter(key), "Enabled")] = tipsinfoState[key].stateResult;
      }
    }
    obj.isAnyTipsinfoEnabled = Object.values(obj).some(value => Boolean(value));
    return obj;
  }, [tipsinfoState]);
  return {
    resultContext,
    standardContext
  };
};
setGlobal('svs.components.tipsen.hooks.useIsTipsinfoEnabled', useIsTipsinfoEnabled);

 })(window);